import IconSvg from 'core/_legacy/icons/IconSvg'

const MastercardLogo = () => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="#555"
  >
    <g id="surface1">
      <path
        d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z"
        fill="#3f51b5"
      />
      <path
        d="M 40 24 C 40 29.523438 35.523438 34 30 34 C 24.476563 34 20 29.523438 20 24 C 20 18.476563 24.476563 14 30 14 C 35.523438 14 40 18.476563 40 24 Z"
        fill="#ffc107"
      />
      <path
        d="M 22.015625 30 C 21.550781 29.382813 21.152344 28.714844 20.839844 28 L 26.164063 28 C 26.441406 27.363281 26.660156 26.695313 26.800781 26 L 20.203125 26 C 20.070313 25.355469 20 24.6875 20 24 L 27 24 C 27 23.3125 26.929688 22.644531 26.800781 22 L 20.199219 22 C 20.34375 21.304688 20.558594 20.636719 20.839844 20 L 26.164063 20 C 25.851563 19.285156 25.453125 18.617188 24.988281 18 L 22.015625 18 C 22.449219 17.421875 22.945313 16.878906 23.496094 16.40625 C 21.746094 14.910156 19.480469 14 17 14 C 11.476563 14 7 18.476563 7 24 C 7 29.523438 11.476563 34 17 34 C 20.269531 34 23.160156 32.425781 24.984375 30 Z"
        fill="#ff3d00"
      />
    </g>
  </IconSvg>
)

export default MastercardLogo
